import React from "react";

const PurchaseSteps = () => {
  return (
    <img
      src={"img/purchase-steps.jpg"}
      alt="購買流程"
      style={{ width: "100%", height: "auto" }}
    />
  );
};

export default PurchaseSteps;
